import { IconButton, Icons } from '@commenda/kakashi';
import {
  downloadFileFromFileId,
  getFileIcon,
  NonTimezoneSensitiveDate,
} from '@commenda/utils';
import { File } from '@prisma/client';

export const DisplaySingleDocumentFile = ({ file }: { file: File }) => {
  const FileIconComponent: React.ElementType = getFileIcon(file.fileName);
  return (
    <div className="bg-bg-primary flex justify-between gap-md items-center p-lg rounded-md border border-border-primary">
      <div className="flex gap-lg items-center">
        <FileIconComponent className="size-10 text-icon-fg-violet shrink-0" />
        <div className="flex flex-col">
          <span className="txt-small-medium">{file.fileName}</span>
          <span className="text-xs text-text-tertiary">
            {NonTimezoneSensitiveDate.fromNativeDate(
              new Date(file.createdAt)
            )?.format('MMMM D, YYYY')}
          </span>
        </div>
      </div>
      <IconButton
        icon={<Icons.Download01 />}
        size="md"
        aria-label="Download"
        onClick={() => {
          downloadFileFromFileId(file.id, file.fileName);
        }}
      />
    </div>
  );
};